var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTeamRefined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 13,
    viewBox: "0 0 35 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_216_401)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M25.0103 12.8565H5.03346L1.22618 8.58324L8.69237 9.75669L0 0L14.6173 3.93235L11.4917 0.429162L35 12.8565L13.7675 7.11673L25.0103 12.8565Z",
    fill: "#EC004C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_216_401"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 12.8565,
    fill: "white",
    transform: "translate(0 0.0717621)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamRefined);
export default __webpack_public_path__ + "static/media/team_refined.b78b387caff43a637ac04a146a444cc1.svg";
export { ForwardRef as ReactComponent };